// ── VERSION ──────────────────────────────────────────────────────
const VERSION = "v4.0.7";
document.title = "Dieseldrachen Charakterblatt · " + VERSION;
document.querySelector(".sheet-page-title").textContent =
    "Dieseldrachen Charakterblatt " + VERSION;

// ── ASSET BASE URL ───────────────────────────────────────────────
// Standalone: window.DD_ASSET_URL is not set → relative paths ("").
// Shopify: set window.DD_ASSET_URL via Liquid in the template before
// loading this script:
//   <script>window.DD_ASSET_URL="{{ 'x' | asset_url | split: 'x' | first }}";</script>
const ASSET = window.DD_ASSET_URL || "";

// ── SKALIERUNG & ZOOM ────────────────────────────────────────────
let userZoom = null; // null = fit mode

function getAvailWidth() {
    // Use dd-content (flex:1 sibling of sidebar) — width is always
    // the true available space regardless of sheet scale.
    const content = document.getElementById("dd-content");
    if (content) {
        const w = content.getBoundingClientRect().width;
        if (w > 0) return w;
    }
    // fallback
    const sidebar = document.getElementById("dd-sidebar");
    const sidebarW = (sidebar && window.innerWidth > 900)
        ? sidebar.getBoundingClientRect().width + 16 : 0;
    const app = document.getElementById("dd-app");
    const appW = app ? app.getBoundingClientRect().width - 40 : window.innerWidth - 40;
    return appW - sidebarW;
}

function scaleSheet() {
    const s = document.getElementById("sheet");
    const fitScale = Math.min(1, getAvailWidth() / 1240);
    const scale = userZoom !== null ? userZoom : fitScale;
    s.style.transform = `scale(${scale})`;
    s.style.transformOrigin = "top left";
    s.style.marginBottom = `${1754 * scale - 1754}px`;
    const sheetArea = document.getElementById("dd-sheet-area");
    if (sheetArea) sheetArea.style.width = Math.round(1240 * scale) + "px";
    const disp = document.getElementById("zoom-display");
    if (disp)
        disp.textContent =
            userZoom !== null
                ? Math.round(scale * 100) + "%"
                : "Fit";
}

const ZOOM_STEPS = [0.25, 0.33, 0.5, 0.67, 0.75, 1.0, 1.25, 1.5, 2.0];
function adjustZoom(dir) {
    const current =
        userZoom !== null
            ? userZoom
            : Math.min(1, getAvailWidth() / 1240);
    if (dir > 0) {
        const next = ZOOM_STEPS.find((z) => z > current + 0.01);
        userZoom = next !== undefined ? next : ZOOM_STEPS[ZOOM_STEPS.length - 1];
    } else {
        const prev = [...ZOOM_STEPS].reverse().find((z) => z < current - 0.01);
        userZoom = prev !== undefined ? prev : ZOOM_STEPS[0];
    }
    scaleSheet();
}
function setZoomFit() {
    userZoom = null;
    scaleSheet();
}

scaleSheet();
window.addEventListener("resize", scaleSheet);

// Scale sheet to fit exactly one A4 page (margin: 0).
// A4 = 210×297 mm; sheet = 1240×1754 px — same √2 aspect ratio.
// At 96 dpi CSS resolution: 210mm = 793.7 px → scale ≈ 0.640.
const PRINT_SCALE = (210 * 96) / 25.4 / 1240;
window.addEventListener("beforeprint", function () {
    const s = document.getElementById("sheet");
    s.style.transformOrigin = "top left";
    s.style.transform = `scale(${PRINT_SCALE})`;
    s.style.marginBottom =
        Math.round(1754 * PRINT_SCALE - 1754) + "px";
});
window.addEventListener("afterprint", function () {
    const s = document.getElementById("sheet");
    s.style.transformOrigin = "";
    s.style.marginBottom = "";
    scaleSheet();
});

function doPrint() {
    const warningBar = document.getElementById("warning-bar");
    const hasWarnings =
        warningBar && warningBar.style.display !== "none";
    if (
        hasWarnings &&
        !confirm(
            "Es gibt aktive Warnungen auf dem Bogen.\nTrotzdem drucken?",
        )
    )
        return;
    window.print();
}

// ── CHARAKTERBILD ────────────────────────────────────────────────
let bgMode = "color";

function updateCharImgVisibility() {
    const imgColor = document.getElementById("char-img");
    const imgBw = document.getElementById("char-img-bw");
    const placeholder = document.getElementById(
        "char-img-placeholder",
    );
    const hasColor =
        imgColor.src && imgColor.src.startsWith("data:");
    const hasBw = imgBw.src && imgBw.src.startsWith("data:");
    if (bgMode === "sw") {
        imgColor.style.display = "none";
        imgBw.style.display = hasBw ? "block" : "none";
        placeholder.style.display = hasBw ? "none" : "";
    } else {
        imgBw.style.display = "none";
        imgColor.style.display = hasColor ? "block" : "none";
        placeholder.style.display = hasColor ? "none" : "";
    }
    // update action buttons: ✕ when image loaded, ⬆ when empty
    const btnColor = document.getElementById("char-img-action-btn");
    if (hasColor) {
        btnColor.textContent = "✕";
        btnColor.title = "Farbbild löschen";
        btnColor.onclick = deleteCharImgColor;
        btnColor.classList.remove("is-upload");
    } else {
        btnColor.textContent = "⬆";
        btnColor.title = "Farbbild laden";
        btnColor.onclick = () =>
            document.getElementById("char-img-input").click();
        btnColor.classList.add("is-upload");
    }
    const btnBw = document.getElementById("char-img-bw-action-btn");
    if (hasBw) {
        btnBw.textContent = "✕";
        btnBw.title = "SW-Bild löschen";
        btnBw.onclick = deleteCharImgBw;
        btnBw.classList.remove("is-upload");
    } else {
        btnBw.textContent = "⬆";
        btnBw.title = "SW-Bild laden";
        btnBw.onclick = () =>
            document.getElementById("char-img-bw-input").click();
        btnBw.classList.add("is-upload");
    }
}

function updateBgBtn() {
    const btn = document.getElementById("bg-toggle-btn");
    if (bgMode === "sw") {
        btn.textContent = "🎨 Farbversion";
        btn.classList.add("bg-btn-color");
        btn.classList.remove("bg-btn-sw");
    } else {
        btn.textContent = "⬛ Schwarzweiß";
        btn.classList.add("bg-btn-sw");
        btn.classList.remove("bg-btn-color");
    }
    document.getElementById("img-btn-color").style.display =
        bgMode === "sw" ? "none" : "";
    document.getElementById("img-btn-sw").style.display =
        bgMode === "sw" ? "" : "none";
}

function charImgClick() {
    document
        .getElementById(
            bgMode === "sw"
                ? "char-img-bw-input"
                : "char-img-input",
        )
        .click();
}

function deleteCharImgColor() {
    if (!confirm("Farbbild löschen?")) return;
    document.getElementById("char-img").src = "";
    localStorage.removeItem("dd_charimg");
    updateCharImgVisibility();
}
function deleteCharImgBw() {
    if (!confirm("SW-Bild löschen?")) return;
    document.getElementById("char-img-bw").src = "";
    localStorage.removeItem("dd_charimg_bw");
    updateCharImgVisibility();
}

function toggleBg() {
    const bg = document.querySelector(".sheet-wrapper img.bg");
    bgMode = bgMode === "color" ? "sw" : "color";
    bg.src =
        bgMode === "sw"
            ? ASSET + "dd-charakterblatt-sw.jpg"
            : ASSET + "dd-charakterblatt-color.jpg";
    updateCharImgVisibility();
    updateBgBtn();
}

function toggleHelp() {
    const p = document.getElementById("help-panel");
    p.style.display =
        p.style.display === "block" ? "none" : "block";
}

function loadCharImg(input) {
    const file = input.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = (e) => {
        document.getElementById("char-img").src = e.target.result;
        localStorage.setItem("dd_charimg", e.target.result);
        updateCharImgVisibility();
    };
    r.readAsDataURL(file);
}

function loadCharImgBw(input) {
    const file = input.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = (e) => {
        document.getElementById("char-img-bw").src =
            e.target.result;
        localStorage.setItem("dd_charimg_bw", e.target.result);
        updateCharImgVisibility();
    };
    r.readAsDataURL(file);
}

// Bilder aus localStorage laden
const savedImg = localStorage.getItem("dd_charimg");
if (savedImg) document.getElementById("char-img").src = savedImg;
const savedImgBw = localStorage.getItem("dd_charimg_bw");
if (savedImgBw)
    document.getElementById("char-img-bw").src = savedImgBw;
updateCharImgVisibility();
updateBgBtn();

// ── WÜRFELBUTTONS ────────────────────────────────────────────────
function updateDice(name, val) {
    const n = val === "" ? null : parseInt(val);
    document
        .querySelectorAll(`.dice-btn[data-field="${name}"]`)
        .forEach((b) => {
            b.classList.toggle(
                "active",
                n !== null && parseInt(b.dataset.val) === n,
            );
        });
}

document.querySelectorAll(".dice-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
        const name = this.dataset.field;
        const val = parseInt(this.dataset.val);
        // Körperlicher Nachteil: cap at W4 (data-val 0)
        if (val > 0 && getActiveNachteile().has(name)) return;
        const inp = document.getElementById(name);
        const cur = inp.value === "" ? null : parseInt(inp.value);
        inp.value = cur === val ? "" : val;
        updateDice(name, inp.value);
        saveToLocal();
    });
    btn.addEventListener("mouseenter", function () {
        document
            .querySelectorAll(
                `.dice-btn[data-field="${this.dataset.field}"]`,
            )
            .forEach((b) => {
                if (!b.classList.contains("active"))
                    b.style.opacity = "0.25";
            });
    });
    btn.addEventListener("mouseleave", function () {
        document
            .querySelectorAll(
                `.dice-btn[data-field="${this.dataset.field}"]`,
            )
            .forEach((b) => {
                if (!b.classList.contains("active"))
                    b.style.opacity = "";
            });
    });
});

// ── EDITOR ───────────────────────────────────────────────────────
let editorMode = false,
    selectedEl = null;

function toggleEditor() {
    editorMode = !editorMode;
    document.getElementById("editor-panel").style.display =
        editorMode ? "block" : "none";
    document.getElementById("editor-toggle").style.background =
        editorMode ? "#e05" : "";
    document.querySelectorAll(".field").forEach((el) => {
        el.style.cursor = editorMode ? "move" : "";
        el.style.outline = editorMode
            ? "1px dashed rgba(200,100,0,0.4)"
            : "";
    });
    if (!editorMode && selectedEl) {
        selectedEl.style.outline = "";
        selectedEl = null;
    }
}

document.querySelectorAll(".field").forEach((el) => {
    el.addEventListener("mousedown", function (e) {
        if (!editorMode) return;
        e.preventDefault();
        e.stopPropagation();
        selectEl(this);
    });
});

function selectEl(el) {
    if (selectedEl)
        selectedEl.style.outline = editorMode
            ? "1px dashed rgba(200,100,0,0.4)"
            : "";
    selectedEl = el;
    el.style.outline = "2px solid #e05";
    document.getElementById("ed-name").textContent =
        el.name || el.id || "–";
    document.getElementById("ed-x").value =
        parseInt(el.style.left) || 0;
    document.getElementById("ed-y").value =
        parseInt(el.style.top) || 0;
    document.getElementById("ed-w").value =
        parseInt(el.style.width) || 0;
    document.getElementById("ed-h").value =
        parseInt(el.style.height) || 0;
    document.getElementById("ed-fs").value =
        parseInt(getComputedStyle(el).fontSize) || 10;
}

function applyCoords() {
    if (!selectedEl) return;
    selectedEl.style.left =
        document.getElementById("ed-x").value + "px";
    selectedEl.style.top =
        document.getElementById("ed-y").value + "px";
    selectedEl.style.width =
        document.getElementById("ed-w").value + "px";
    selectedEl.style.height =
        document.getElementById("ed-h").value + "px";
    selectedEl.style.fontSize =
        document.getElementById("ed-fs").value + "px";
}

["ed-x", "ed-y", "ed-w", "ed-h", "ed-fs"].forEach((id) => {
    document
        .getElementById(id)
        .addEventListener("input", applyCoords);
});

document.addEventListener("keydown", (e) => {
    if (!editorMode || !selectedEl) return;
    if (
        ![
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
        ].includes(e.key)
    )
        return;
    e.preventDefault();
    const step = e.shiftKey ? 10 : 1;
    const xIn = document.getElementById("ed-x");
    const yIn = document.getElementById("ed-y");
    if (e.key === "ArrowLeft") xIn.value = +xIn.value - step;
    if (e.key === "ArrowRight") xIn.value = +xIn.value + step;
    if (e.key === "ArrowUp") yIn.value = +yIn.value - step;
    if (e.key === "ArrowDown") yIn.value = +yIn.value + step;
    applyCoords();
});

function copyCoords() {
    if (!selectedEl) return;
    const txt = `"${selectedEl.name}": Links=${selectedEl.style.left} Oben=${selectedEl.style.top} Breite=${selectedEl.style.width} Höhe=${selectedEl.style.height} Schrift=${selectedEl.style.fontSize}`;
    navigator.clipboard.writeText(txt);
}

// ── XFDF IMPORT ──────────────────────────────────────────────────
function loadXFDF(input) {
    const file = input.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = (e) => parseXFDF(e.target.result);
    r.readAsText(file, "UTF-8");
    input.value = "";
}
const SOZIALSTATUS_IDS = [
    "Gruppe",
    "Kontakte",
    "Ruf",
    "Stand",
    "Besitz",
    "Gruppe Wert",
    "Kontakte Wert",
    "Ruf Wert",
    "Stand Wert",
    "Vermoegen Wert",
];

function resetAll() {
    if (
        !confirm(
            "⚠️ ACHTUNG — Alles zurücksetzen?\n\nAlle Felder und Würfelwerte werden unwiderruflich gelöscht.\nDer gespeicherte Stand im Browser wird ebenfalls entfernt.\n\nCharakterbilder bleiben erhalten.",
        )
    )
        return;
    if (
        !confirm(
            "Wirklich? Diese Aktion kann NICHT rückgängig gemacht werden.",
        )
    )
        return;
    document
        .querySelectorAll('.field, input[type="hidden"]')
        .forEach((el) => {
            el.value = "";
            if (el.type === "hidden") updateDice(el.name, "");
        });
    updateGesundheit();
    updatePunkteBox();
    localStorage.removeItem("dd_charsheet");
}

function parseXFDF(xml) {
    // Clear Sozialstatus before import so missing entries become empty
    SOZIALSTATUS_IDS.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
            el.value = "";
            if (el.type === "hidden") updateDice(id, "");
        }
    });
    const doc = new DOMParser().parseFromString(xml, "text/xml");
    let count = 0;
    function process(el, parent) {
        const name = el.getAttribute("name");
        const valueEl = Array.from(el.children).find(
            (c) => c.tagName === "value",
        );
        if (valueEl) {
            const val = valueEl.textContent;
            const target = document.getElementById(name);
            if (target) {
                target.value = val;
                if (target.type === "hidden") updateDice(name, val);
                count++;
            }
        }
        Array.from(el.children)
            .filter((c) => c.tagName === "field")
            .forEach((c) => process(c, name));
    }
    doc.querySelectorAll("fields > field").forEach((f) =>
        process(f, ""),
    );
    saveToLocal();
    updateGesundheit();
    updatePunkteBox();
    alert(`XFDF importiert: ${count} Felder geladen.`);
}

// ── XFDF EXPORT ──────────────────────────────────────────────────
function exportXFDF() {
    let xml = "";
    document
        .querySelectorAll('.field, input[type="hidden"]')
        .forEach((el) => {
            if (!el.name || el.value === "") return;
            const n = el.name
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;");
            const v = el.value
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
            xml += `  <field name="${n}"><value>${v}</value></field>\n`;
        });
    const name =
        document.getElementById("Name")?.value || "Charakter";
    const full = `<?xml version="1.0" encoding="UTF-8"?>\n<xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve">\n<fields>\n${xml}</fields>\n</xfdf>`;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(
        new Blob([full], { type: "application/xml" }),
    );
    a.download =
        name.replace(/[^\w\s\-äöüÄÖÜß]/g, "") +
        "_" +
        VERSION +
        ".xfdf";
    a.click();

    // Download character images if present
    const safeName = name.replace(/[^\w\s\-äöüÄÖÜß]/g, "");
    const imgColor = localStorage.getItem("dd_charimg");
    if (imgColor) {
        const ext = imgColor.split(";")[0].split("/")[1] || "jpg";
        const ai = document.createElement("a");
        ai.href = imgColor;
        ai.download = safeName + "_Bild." + ext;
        ai.click();
    }
    const imgBw = localStorage.getItem("dd_charimg_bw");
    if (imgBw) {
        const ext = imgBw.split(";")[0].split("/")[1] || "jpg";
        const ab = document.createElement("a");
        ab.href = imgBw;
        ab.download = safeName + "_Bild_SW." + ext;
        ab.click();
    }
}

// ── LOCALSTORAGE ─────────────────────────────────────────────────
function saveToLocal() {
    const data = {};
    document
        .querySelectorAll('.field,input[type="hidden"]')
        .forEach((el) => {
            if (el.name) data[el.name] = el.value;
        });
    try {
        localStorage.setItem("dd_charsheet", JSON.stringify(data));
    } catch (e) {}
}
function loadFromLocal() {
    try {
        const d = JSON.parse(
            localStorage.getItem("dd_charsheet") || "null",
        );
        if (!d) return;
        for (const [k, v] of Object.entries(d)) {
            const el = document.getElementById(k);
            if (!el) continue;
            el.value = v;
            if (el.type === "hidden") updateDice(k, v);
        }
    } catch (e) {}
}
document.querySelectorAll(".field").forEach((el) => {
    el.addEventListener("input", saveToLocal);
    el.addEventListener("change", saveToLocal);
});
// Würfelbuttons: X-Positionen auf PDF-Weißfelder ausrichten (aus Annotation-Layer)
const _diceX = { W4: 160, W6: 190, W8: 222, W10: 253, W12: 284 };
document.querySelectorAll(".dice-btn").forEach((btn) => {
    if ("freePos" in btn.dataset) return;
    const x = _diceX[btn.title];
    if (x !== undefined) {
        btn.style.left = x + "px";
        btn.style.width = "29px";
    }
});

// ── GESUNDHEIT ───────────────────────────────────────────────────
const GESUNDHEIT_TOP = 30; // top of first box (Gesundheit32) in px
const GESUNDHEIT_STEP = 53.7; // distance between boxes in px
(function positionGesundheitBoxes() {
    for (let i = 1; i <= 32; i++) {
        const box = document.getElementById("Gesundheit" + i);
        if (box)
            box.style.top =
                GESUNDHEIT_TOP + (32 - i) * GESUNDHEIT_STEP + "px";
    }
})();

const _dieFace = { "": 0, 0: 4, 1: 6, 3: 8, 6: 10, 10: 12 };
function getSpeziesValue() {
    const s = (
        document.getElementById("Spezies")?.value || ""
    ).toLowerCase();
    if (
        s.includes("halbling") ||
        s.includes("goblin") ||
        s.includes("gobling")
    )
        return 4;
    if (s.includes("troll")) return 8;
    if (s.length > 0) return 6;
    return 0;
}
function hasRobustTrick() {
    return ["Tricks1", "Tricks2", "Tricks3"].some((id) => {
        const el = document.getElementById(id);
        return el && el.value.trim().startsWith("Robust");
    });
}
function getBlockedCount() {
    const a = document.getElementById("Athletik")?.value ?? "";
    const k = document.getElementById("Kondition")?.value ?? "";
    const robustBonus = hasRobustTrick() ? 4 : 0;
    const gesundheit =
        (_dieFace[a] ?? 0) +
        (_dieFace[k] ?? 0) +
        getSpeziesValue() +
        robustBonus;
    return Math.max(0, 32 - gesundheit);
}
function updateGesundheit() {
    const blocked = getBlockedCount();
    for (let i = 1; i <= 32; i++) {
        const box = document.getElementById("Gesundheit" + i);
        const inp = document.getElementById(
            "Gesundheit" + i + "_val",
        );
        if (!box) continue;
        box.className = "gesundheit-box";
        if (i >= 33 - blocked) {
            box.classList.add("blocked");
        } else {
            const st = inp?.value || "";
            if (st === "1") box.classList.add("damage");
            else if (st === "2") box.classList.add("exhausted");
        }
    }
}
document.querySelectorAll(".gesundheit-box").forEach((box) => {
    box.addEventListener("click", function () {
        if (this.classList.contains("blocked")) return;
        const inp = document.getElementById(this.id + "_val");
        const cur = inp?.value || "";
        inp.value = cur === "" ? "1" : cur === "1" ? "2" : "";
        updateGesundheit();
        saveToLocal();
    });
});
// ── INGAME AKTIONEN ──────────────────────────────────────────────
function erholenAction() {
    if (!confirm("Erholen: Alle Erschöpfung / jetzt löschen?"))
        return;
    for (let i = 1; i <= 32; i++) {
        const inp = document.getElementById(
            "Gesundheit" + i + "_val",
        );
        if (inp && inp.value === "2") inp.value = ""; // clear /
    }
    updateGesundheit();
    saveToLocal();
}

function heilenAction() {
    const kondVal =
        document.getElementById("Kondition")?.value ?? "";
    const maxHeal = _dieFace[kondVal] ?? 0;
    if (maxHeal === 0) {
        alert("Kein Kondition-Würfelwert gesetzt.");
        return;
    }
    if (!confirm(`Heilen: Bis zu ${maxHeal} × X in / umwandeln?`))
        return;
    let healed = 0;
    for (let i = 1; i <= 32 && healed < maxHeal; i++) {
        const inp = document.getElementById(
            "Gesundheit" + i + "_val",
        );
        if (inp && inp.value === "1") {
            // X → /
            inp.value = "2";
            healed++;
        }
    }
    sortGesundheit();
    updateGesundheit();
    saveToLocal();
}

function sortGesundheit() {
    const blocked = getBlockedCount();
    const activeMax = 32 - blocked;
    // collect all marks in active range
    const marks = [];
    for (let i = 1; i <= activeMax; i++) {
        const inp = document.getElementById(
            "Gesundheit" + i + "_val",
        );
        if (inp) marks.push(inp.value);
    }
    // sort: empty at bottom (low indices), / above, X at top (high indices)
    marks.sort((a, b) => {
        const order = { "": 0, 2: 1, 1: 2 };
        return order[a] - order[b];
    });
    // write back
    for (let i = 1; i <= activeMax; i++) {
        const inp = document.getElementById(
            "Gesundheit" + i + "_val",
        );
        if (inp) inp.value = marks[i - 1];
    }
}

// Recalc health when Athletik or Kondition dice change
document
    .querySelectorAll(
        '.dice-btn[data-field="Athletik"], .dice-btn[data-field="Kondition"]',
    )
    .forEach((btn) =>
        btn.addEventListener("click", updateGesundheit),
    );
// Recalc health when Spezies changes
document
    .getElementById("Spezies")
    ?.addEventListener("input", updateGesundheit);
document
    .getElementById("Spezies")
    ?.addEventListener("change", updateGesundheit);

// ── PUNKTE-ZÄHLER ────────────────────────────────────────────────
const ATTRIBUTE = [
    "Athletik",
    "Geschick",
    "Reaktion",
    "Charisma",
    "Intuition",
    "Verstand",
    "Magie",
];
const FAEHIGKEITEN = [
    "Kraft",
    "Gewandtheit",
    "Kondition",
    "Pistolen",
    "Gewehre",
    "Fingerfertigkeit",
    "Prügeln",
    "Fechten",
    "Lenken",
    "Überreden",
    "Schauspiel",
    "Gesellschaft",
    "Orientierung",
    "Verstohlenheit",
    "Wachsamkeit",
    "Wissen",
    "Willensstärke",
    "Suchen",
    "Körper/Sinne",
    "Schicksal/Geister",
    "Elemente/Energie",
];
const _dieCost = { "": 0, 0: 0, 1: 1, 3: 3, 6: 6, 10: 10 };

const DICE_COLORS = {
    W4: "#5db8c8",
    W6: "#72bb45",
    W8: "#f5c040",
    W10: "#d96830",
    W12: "#cc3535",
};
const DICE_IMGS = {
    W4: ASSET + "dice-4c.png",
    W6: ASSET + "dice-6c.png",
    W8: ASSET + "dice-8c.png",
    W10: ASSET + "dice-10c.png",
    W12: ASSET + "dice-12c.png",
};
// Tricks that grant a W10 minimum for their Sozialstatus field
const SOZIAL_TRICK_MAP = {
    Adelig: "Stand Wert",
    Berühmt: "Ruf Wert",
    Gruppe: "Gruppe Wert",
    Netzwerk: "Kontakte Wert",
    Reich: "Vermoegen Wert",
};
const MAGIC_TRICKS = [
    "Chaotischer Magier",
    "Elementarmagier",
    "Intuitivmagier (fremd)",
    "Intuitivmagier (selbst)",
    "Medium",
    "Verkopfter Zauberer",
    "Zyklischer Magier (Tag)",
    "Zyklischer Magier (Nacht)",
];
const MAGIC_FIELDS = [
    "Magie",
    "Körper/Sinne",
    "Schicksal/Geister",
    "Elemente/Energie",
];

// ── NACHTEIL / BEGABUNG ──────────────────────────────────────────
const NACHTEIL_FIELDS = {
    "Körperlicher Nachteil: Athletik": "Athletik",
    "Körperlicher Nachteil: Fingerfertigkeit": "Fingerfertigkeit",
    "Körperlicher Nachteil: Gewandtheit": "Gewandtheit",
    "Körperlicher Nachteil: Kondition": "Kondition",
    "Körperlicher Nachteil: Kraft": "Kraft",
};
const BEGABUNG_FIELDS = {
    "Begabung: Fechten": "Fechten",
    "Begabung: Fingerfertigkeit": "Fingerfertigkeit",
    "Begabung: Gesellschaft": "Gesellschaft",
    "Begabung: Gewandtheit": "Gewandtheit",
    "Begabung: Gewehre": "Gewehre",
    "Begabung: Kondition": "Kondition",
    "Begabung: Kraft": "Kraft",
    "Begabung: Lenken": "Lenken",
    "Begabung: Orientierung": "Orientierung",
    "Begabung: Pistolen": "Pistolen",
    "Begabung: Prügeln": "Prügeln",
    "Begabung: Schauspiel": "Schauspiel",
    "Begabung: Suchen": "Suchen",
    "Begabung: Überreden": "Überreden",
    "Begabung: Verstohlenheit": "Verstohlenheit",
    "Begabung: Wachsamkeit": "Wachsamkeit",
    "Begabung: Wissen": "Wissen",
};

function getActiveNachteile() {
    const s = document.getElementById("Spleen")?.value.trim() || "";
    const result = new Set();
    for (const [key, field] of Object.entries(NACHTEIL_FIELDS)) {
        if (s.startsWith(key)) result.add(field);
    }
    return result;
}
function getActiveBegabungen() {
    const result = new Set();
    ["Tricks1", "Tricks2", "Tricks3"].forEach((id) => {
        const v = document.getElementById(id)?.value.trim() || "";
        for (const [key, field] of Object.entries(
            BEGABUNG_FIELDS,
        )) {
            if (v.startsWith(key)) result.add(field);
        }
    });
    return result;
}

// Inject one indicator span per affected field
(function createFieldIcons() {
    const allFields = new Set([
        ...Object.values(NACHTEIL_FIELDS),
        ...Object.values(BEGABUNG_FIELDS),
    ]);
    const sheet = document.getElementById("sheet");
    allFields.forEach((field) => {
        const w4 = document.querySelector(
            `.dice-btn[data-field="${field}"][data-val="0"]`,
        );
        if (!w4) return;
        const left = parseInt(w4.style.left);
        const top = parseInt(w4.style.top);
        const h = parseInt(w4.style.height);
        const span = document.createElement("span");
        span.id = `field-icon-${field}`;
        span.dataset.baseTop = top + 1;
        span.style.cssText = `position:absolute;left:10px;top:${top + 1}px;width:30px;height:${h - 2}px;line-height:${h - 2}px;text-align:center;font-weight:bold;cursor:default;display:none;z-index:6;`;
        sheet.appendChild(span);
    });
})();

function updatePunkteBox() {
    // Fähigkeiten budget
    let spent = 0;
    FAEHIGKEITEN.forEach((name) => {
        const el = document.getElementById(name);
        if (el) spent += _dieCost[el.value] ?? 0;
    });
    const ratio = spent / 30;
    const spentColor =
        ratio > 1
            ? "#e84040"
            : ratio > 0.8
              ? "#d96830"
              : ratio > 0
                ? "#72bb45"
                : "#7a6a50";
    document.getElementById("faehigkeiten-wert").innerHTML =
        `<span style="color:${spentColor};font-size:17px">${spent}</span>` +
        `<span style="color:#7a6a50"> / 30</span>`;

    // Attribute die counts — always show all 5
    const counts = { W4: 0, W6: 0, W8: 0, W10: 0, W12: 0 };
    ATTRIBUTE.forEach((name) => {
        const el = document.getElementById(name);
        if (!el || el.value === "") return;
        const face = _dieFace[el.value];
        if (face) counts["W" + face]++;
    });
    const slots = ["W4", "W6", "W8", "W10", "W12"].map((w) => {
        const n = counts[w];
        const active = n > 0;
        const col = active ? DICE_COLORS[w] : "#4a3e2e";
        const op = active ? "1" : "0.25";
        return (
            `<span class="die-slot">` +
            `<img src="${DICE_IMGS[w]}" class="die-img" style="opacity:${op}">` +
            `<span style="color:${col}">${n}×${w}</span>` +
            `</span>`
        );
    });
    document.getElementById("attribut-wert").innerHTML =
        slots.join("");

    // Sozialstatus-Punkte
    const sozialIds = [
        "Gruppe Wert",
        "Kontakte Wert",
        "Ruf Wert",
        "Stand Wert",
        "Vermoegen Wert",
    ];

    // Determine which fields have an active social Trick
    // Matches exact ("Berühmt") or expanded ("Berühmt: Sänger")
    const activeTrickFields = new Set();
    ["Tricks1", "Tricks2", "Tricks3"].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        const val = el.value.trim();
        for (const [trick, field] of Object.entries(
            SOZIAL_TRICK_MAP,
        )) {
            if (val.startsWith(trick)) {
                activeTrickFields.add(field);
                break;
            }
        }
    });

    // Check if any trick-active field has an invalid (below W10) selection
    const SOZIAL_TRICK_NAMES = Object.fromEntries(
        Object.entries(SOZIAL_TRICK_MAP).map(([k, v]) => [v, k]),
    );
    const violatingTricks = [];
    sozialIds.forEach((fieldId) => {
        if (!activeTrickFields.has(fieldId)) return;
        const inp = document.getElementById(fieldId);
        if (inp && inp.value !== "" && parseInt(inp.value) < 2) {
            violatingTricks.push(SOZIAL_TRICK_NAMES[fieldId]);
        }
    });

    // Calculate sum; W10 baseline = 0 when trick is active (offset -2)
    let sozialSum = 0,
        sozialAny = false;
    sozialIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.value !== "") {
            const offset = activeTrickFields.has(id) ? -2 : 0;
            sozialSum += parseInt(el.value) + offset;
            sozialAny = true;
        }
    });

    const sozialHTML = !sozialAny
        ? `<span style="color:#7a6a50">—</span>`
        : (() => {
              const sc =
                  sozialSum > 0
                      ? "#72bb45"
                      : sozialSum < 0
                        ? "#e84040"
                        : "#7a6a50";
              return `<span style="color:${sc};font-size:17px;font-family:'Josefin Sans',sans-serif;font-weight:bold">${sozialSum > 0 ? "+" : ""}${sozialSum}</span>`;
          })();
    document.getElementById("sozial-wert").innerHTML = sozialHTML;
    const sozialInlineEl =
        document.getElementById("sozial-wert-inline");
    if (sozialInlineEl) {
        const warnIcon = violatingTricks.length
            ? ` <span style="color:#e84040;font-size:14px;">⚠</span>`
            : "";
        sozialInlineEl.innerHTML = sozialHTML + warnIcon;
    }

    // Wissensbereiche counter (Verstand + Wissen + 5 (+ 5 if Gebildet))
    const verstandEl = document.getElementById("Verstand");
    const wissenEl = document.getElementById("Wissen");
    const hasGebildet = ["Tricks1", "Tricks2", "Tricks3"].some(
        (id) => {
            const el = document.getElementById(id);
            return el && el.value.trim().startsWith("Gebildet");
        },
    );
    const wissensCount =
        (_dieFace[verstandEl?.value ?? ""] ?? 0) +
        (_dieFace[wissenEl?.value ?? ""] ?? 0) +
        (hasGebildet ? 5 : 0);
    const wissensAny =
        (verstandEl?.value ?? "") !== "" ||
        (wissenEl?.value ?? "") !== "";
    const wissensHTML = !wissensAny
        ? `<span style="color:#7a6a50">—</span>`
        : `<span style="color:#7a6a50;font-size:17px;font-family:'Josefin Sans',sans-serif;font-weight:bold">(${wissensCount})</span>`;
    document.getElementById("wissens-wert").innerHTML = wissensHTML;
    // Nachteil / Begabung icons and W4-cap visual feedback
    const activeNachteile = getActiveNachteile();
    const activeBegabungen = getActiveBegabungen();
    const spleenText = document.getElementById("Spleen")?.value.trim() || "";
    const begabungTricks = {};
    ["Tricks1", "Tricks2", "Tricks3"].forEach((id) => {
        const v = document.getElementById(id)?.value.trim() || "";
        for (const [key, field] of Object.entries(BEGABUNG_FIELDS)) {
            if (v.startsWith(key)) begabungTricks[field] = v;
        }
    });
    const allIconFields = new Set([
        ...Object.values(NACHTEIL_FIELDS),
        ...Object.values(BEGABUNG_FIELDS),
    ]);
    allIconFields.forEach((field) => {
        const icon = document.getElementById(`field-icon-${field}`);
        const hasN = activeNachteile.has(field);
        const hasB = activeBegabungen.has(field);
        if (!hasN && !hasB) {
            if (icon) icon.style.display = "none";
        } else {
            if (icon) {
                icon.style.display = "";
                const baseTop = parseInt(icon.dataset.baseTop);
                if (hasN && hasB) {
                    icon.textContent = "▼★";
                    icon.style.color = "#e84040";
                    icon.style.fontSize = "20px";
                    icon.style.top = baseTop - 6 + "px";
                    icon.title = [spleenText, begabungTricks[field]].filter(Boolean).join("\n");
                } else if (hasN) {
                    icon.textContent = "▼";
                    icon.style.color = "#e84040";
                    icon.style.fontSize = "20px";
                    icon.style.top = baseTop - 7 + "px";
                    icon.title = spleenText;
                } else {
                    icon.textContent = "★";
                    icon.style.color = "#f5c040";
                    icon.style.fontSize = "30px";
                    icon.style.top = baseTop - 5 + "px";
                    icon.title = begabungTricks[field] || "";
                }
            }
        }
        // Dim W6–W12 buttons for fields with Nachteil
        document
            .querySelectorAll(`.dice-btn[data-field="${field}"]`)
            .forEach((b) => {
                if (hasN && parseInt(b.dataset.val) > 0) {
                    b.classList.add("nachteil-blocked");
                } else {
                    b.classList.remove("nachteil-blocked");
                }
            });
    });

    // Duplicate trick check
    const trickVals = ["Tricks1", "Tricks2", "Tricks3"]
        .map(
            (id) => document.getElementById(id)?.value.trim() || "",
        )
        .filter((v) => v !== "");
    const trickDupes = [
        ...new Set(
            trickVals.filter((v, i) => trickVals.indexOf(v) !== i),
        ),
    ];

    // Warning bar — collect all warnings
    const warnings = [];

    if (trickDupes.length) {
        warnings.push(
            `Trick "${trickDupes.join('", "')}" wurde mehrfach gewählt.`,
        );
    }

    // Nachteil + Begabung on same field
    const nachteiBegabungOverlap = [...activeNachteile].filter(
        (f) => activeBegabungen.has(f),
    );
    if (nachteiBegabungOverlap.length) {
        warnings.push(
            `${nachteiBegabungOverlap.join(", ")}: Körperlicher Nachteil und Begabung gleichzeitig gewählt.`,
        );
    }

    if (violatingTricks.length) {
        warnings.push(
            `${violatingTricks.join(", ")}: W10 ist das Minimum — niedrigere Würfel sind nicht erlaubt.`,
        );
    }

    // Magie check: any magic field above W4 requires a magic trick
    const hasMagicTrick = ["Tricks1", "Tricks2", "Tricks3"].some(
        (id) => {
            const el = document.getElementById(id);
            if (!el) return false;
            const val = el.value.trim();
            return MAGIC_TRICKS.some((t) => val.startsWith(t));
        },
    );
    const hasMagicRaised = MAGIC_FIELDS.some((id) => {
        const el = document.getElementById(id);
        return el && el.value !== "" && parseInt(el.value) > 0;
    });
    const magieWarn = document.getElementById("magie-warn");
    if (hasMagicRaised && !hasMagicTrick) {
        warnings.push("Magie steigern benötigt Magie-Trick");
        if (magieWarn) magieWarn.style.display = "";
    } else {
        if (magieWarn) magieWarn.style.display = "none";
    }

    const warningBar = document.getElementById("warning-bar");
    if (warningBar) {
        if (warnings.length) {
            warningBar.innerHTML = warnings
                .map((w) => `⚠ ${w}`)
                .join("<br>");
            warningBar.style.display = "";
        } else {
            warningBar.style.display = "none";
        }
    }
}
document
    .querySelectorAll(".dice-btn")
    .forEach((btn) =>
        btn.addEventListener("click", updatePunkteBox),
    );
// Re-evaluate when Tricks change (social tricks, Robust, Gebildet)
["Tricks1", "Tricks2", "Tricks3"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
        el.addEventListener("input", updatePunkteBox);
        el.addEventListener("input", updateGesundheit);
    }
});
// Re-evaluate when Spleen changes (Körperlicher Nachteil)
const spleenEl = document.getElementById("Spleen");
if (spleenEl) spleenEl.addEventListener("input", updatePunkteBox);

// ── KRAFTW AUTO-FILL ─────────────────────────────────────────────
document
    .querySelectorAll('.dice-btn[data-field="Kraft"]')
    .forEach((btn) => {
        btn.addEventListener("click", function () {
            const val = document.getElementById("Kraft").value;
            document.getElementById("KraftW").value =
                val !== "" ? (_dieFace[val] ?? "") : "";
            saveToLocal();
        });
    });

loadFromLocal();
[
    "Fernkampfwaffe1typ",
    "Fernkampfwaffe2typ",
    "Fernkampfwaffe3typ",
].forEach(updateWaffentypIcon);
updateGesundheit();
updatePunkteBox();
